import * as angular from "angular";
import {IController} from "angular";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {BranchModel} from "../../models/branch.model";

export class branchesIndicatorCtrl implements IController {

  branches: BranchModel[];
  branchIds: any;
  isMultiline: boolean;
  canFilterByValues: boolean;
  isShowOnlyText: boolean;
  onFilterByType: Function;

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;

  constructor(private $branches) {
  }

  $onInit() {
    if (this.branchIds && this.branchIds.length) {
      this._getBranches()
    }
  }

  $onChanges(changes) {
    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      if (this.branchIds && this.branchIds.length) {
        this._getBranches()
      }
    }
  }

  onFilterByBranches() {
    this.branchIds = this.branches.map(b => b.id);
    this.onFilterByType({type: this.siteFiltersType.branchIds, value: this.branchIds});
  }

  private _getBranches() {
    this.branches = [];
    this.$branches().$asyncValues(this.branchIds)
      .then((branches: BranchModel[]) => {
        this.branches = branches;
      })
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchesIndicator', {
    bindings: {
      branches: '<?',
      branchIds: '<?',
      isMultiline: '<?',
      canFilterByValues: '<?',
      isShowOnlyText: '<?',
      onFilterByType: '&'
    },
    template: require('./branches-indicator.html').default,
    controller: branchesIndicatorCtrl
  });
